const en = {
  title: "Languages",
  description: "Sell in more than one language. Your dashboard language is set separately in the top bar; these are the languages your customers can read your store in.",
  storefrontLanguages: "Storefront languages",
  storefrontLanguagesHint: "The default language is the one your content is written in. Extra languages stay hidden from customers until you publish them.",
  addLanguage: "Add language",
  default: "Default",
  publishedBadge: "Published",
  hiddenBadge: "Hidden from customers",
  preview: "Preview ↗",
  manageTranslations: "Translations",
  noneYet: "No extra languages yet. Add one to start translating your store.",
  enabled: "Language added. It stays hidden until you publish it.",
  removed: "Language removed.",
  publish: "Publish",
  unpublish: "Unpublish",
  publishTitle: "Publish {language}?",
  publishBody: "Customers will be able to switch to this language. All its draft translations go live; text that isn't translated yet shows in your default language.",
  unpublishTitle: "Hide {language}?",
  unpublishBody: "Customers won't see this language any more. Translations are kept.",
  removeTitle: "Remove {language}?",
  removeBody: "The language and all its translations will be deleted.",
  publishedMsg: "Language published.",
  unpublishedMsg: "Language hidden from customers.",
  translationsFor: "{language} translations",
  completeness: "{percent}% of your store's text is translated.",
  completenessLabel: "Translation completeness",
  hiddenNote: "This language is hidden from customers. Use Preview to check it, then publish it when you're ready.",
  colContent: "Content",
  colStatus: "Status",
  colProgress: "Fields",
  status_missing: "Not translated",
  status_partial: "Partly translated",
  status_complete: "Translated",
  status_outdated: "Outdated",
  unpublishedChanges: "Unpublished changes",
  machineTranslated: "AI translation",
  edit: "Edit",
  type_store: "Store",
  type_page: "Page",
  type_menu: "Menu",
  type_collection: "Collection",
  type_product: "Product",
  aiTranslateMissing: "Translate missing with AI",
  aiTranslateThis: "Translate with AI",
  aiWorking: "Translating…",
  aiUnavailable: "AI translation isn't configured on this server.",
  aiDone: "Translated {count} items as drafts. Review them before publishing.",
  aiDone_one: "Translated 1 item as a draft. Review it before publishing.",
  editorHint: "Translate from {from} to {to}. Prices, SKUs, images and links always come from the original.",
  outdatedNote: "The original text changed after this was translated. Check the fields below.",
  field_title: "Title",
  field_description: "Description",
  field_seoTitle: "SEO title",
  field_seoDescription: "SEO description",
  field_menuLabel: "Menu label",
  field_section: "Section",
  saveDraft: "Save draft",
  savedDraft: "Translation saved as a draft.",
  publishThis: "Publish this translation",
  aiRemaining: "{count} more items still need translating — click again to continue.",
  translationPublished: "Translation published.",
};

export default en;
